import React from "react";
import { NavLink } from "react-router-dom";
import useTranslation from "../../../i18n/useTranslation";
import { GlobalStyles } from "../../../constants/styles";
import BrandName from "../BrandName";

const PublicFooter = ({ imgPath = "/dist/img/" }) => {
    const year = new Date().getFullYear();
    const {t} = useTranslation();

    return (
        <footer
            className="public-footer"
            style={{
                "--footer-accent": GlobalStyles.colors.brandBlue,
                "--footer-orange": GlobalStyles.colors.brandOrange
            }}
        >
            <style>{`
                .public-footer {
                    background: linear-gradient(135deg, ${GlobalStyles.colors.woodsmoke} 0%, var(--kbs-background-alt, #0b0d15) 100%);
                    border-top: 3px solid var(--footer-accent);
                    color: ${GlobalStyles.colors.white};
                    margin-top: auto;
                    padding: 42px 0 22px;
                }
                .public-footer__container {
                    display: grid;
                    gap: 32px;
                    grid-template-columns: repeat(3, minmax(0, 1fr));
                }
                .public-footer__brand {
                    align-items: center;
                    display: flex;
                    flex-direction: column;
                    gap: 18px;
                    text-align: center;
                }
                .public-footer__brand-link { justify-content: center; width: 100%; }
                .public-footer__brand-link,
                .public-footer__powered-link { align-items: center; display: flex; gap: 16px; }
                .public-footer__powered-link { flex-direction: column; gap: 8px; justify-content: center; text-align: center; width: 100%; }
                .public-footer__brand-name { color: ${GlobalStyles.colors.white}; font-size: 1.35rem; font-weight: 800; letter-spacing: -.02em; line-height: 1.2; }
                .public-footer__brand-copy,
                .public-footer__contact,
                .public-footer__legal,
                .public-footer__powered-label { color: ${GlobalStyles.colors.manatee}; font-size: .9rem; line-height: 1.6; margin-bottom: 0; }
                .public-footer__brand-copy { margin-top: 6px; max-width: 270px; }
                .public-footer__section-label { color: var(--footer-accent); font-size: .7rem; font-weight: 800; letter-spacing: .14em; margin-bottom: 14px; text-transform: uppercase; }
                .public-footer__center { border-left: 1px solid rgba(255,255,255,.12); padding-left: 32px; }
                .public-footer__link--primary,
                .public-footer__email { color: ${GlobalStyles.colors.white}; font-weight: 700; }
                .public-footer__link--primary:hover,
                .public-footer__email:hover,
                .public-footer__powered-link:hover { color: var(--footer-accent); opacity: .85; text-decoration: none; }
                .public-footer__logo--kbola { background: transparent; border-radius: 12px; box-sizing: border-box; max-height: 72px; }
                .public-footer__logo--angeonx { max-height: 600px; max-width: 1920px; transform: scale(2); transform-origin: center; }
                .public-footer__powered { align-self: center; border-left: 1px solid rgba(255,255,255,.12); padding: 16px 0 16px 32px; }
                .public-footer__bottom { border-top: 1px solid rgba(255,255,255,.1); color: ${GlobalStyles.colors.manatee}; font-size: .78rem; margin-top: 34px; padding-top: 18px; }
                @media (max-width: 768px) {
                    .public-footer__container { grid-template-columns: 1fr; text-align: center; }
                    .public-footer__brand, .public-footer__powered-link { align-items: center; }
                    .public-footer__center { border-left: 0; border-top: 1px solid rgba(255,255,255,.12); padding-left: 0; padding-top: 26px; width: 100%; }
                    .public-footer__brand-copy { max-width: none; }
                    .public-footer__powered { border-left: 0; border-top: 1px solid rgba(255,255,255,.12); justify-self: center; padding: 26px 0 0; width: 100%; }
                }
            `}</style>
            <div className="container public-footer__container">
                <div className="public-footer__brand">
                    <NavLink to="/" className="public-footer__brand-link">
                        <img
                            src={`${imgPath}angeonx-sports.png`}
                            alt="AngeonX Sports"
                            className="public-footer__logo public-footer__logo--kbola"
                        />
                    </NavLink>
                    <div className="public-footer__brand-text">
                        <BrandName
                            className="public-footer__brand-name"
                            size="1.35rem"
                            sportsStyle={{fontStyle: "italic", marginLeft: 4}}
                        />
                        <div className="public-footer__brand-copy">{t('home.footer.brandTitle')}</div>
                    </div>
                </div>

                <div className="public-footer__center">
                    <div className="public-footer__section-label">{t('home.footer.contact')}</div>
                    <NavLink to="/terms" className="public-footer__link public-footer__link--primary">
                        {t('home.footer.terms')}
                    </NavLink>
                    <p className="public-footer__contact">
                        {t('home.footer.contact')}: {" "}
                        <a href="mailto:kbolasports@angeonx.com" className="public-footer__email">
                            kbolasports@angeonx.com
                        </a>
                    </p>
                    <div className="public-footer__legal">{t('home.footer.rights', { year })}</div>
                </div>

                <div className="public-footer__powered">
                    <a href="https://www.angeonx.com" target="_blank" rel="noreferrer" className="public-footer__powered-link">
                        <span className="public-footer__powered-label">{t('home.footer.poweredBy')}</span>
                        <img
                            src={`${imgPath}angeonx-white.png`}
                            alt="AngeonX Inc."
                            className="public-footer__logo public-footer__logo--angeonx"
                        />
                    </a>
                </div>
            </div>
            <div className="container public-footer__bottom">{t('home.footer.angeonx')}</div>
        </footer>
    );
};

export default PublicFooter;
